import React from 'react'
import { Box, Typography } from '@mui/material'

const FallbackCustomView = ({ message }) => {
  return (
    <Box
      id="fallback-comp"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f8d7da',
        borderRadius: '4px',
        padding: '16px',
        boxShadow: '2px 2px 4px rgba(0,0,0,0.2)',
      }}
    >
      <Typography variant="h6" color="error">
        {message || 'Module not available'}
      </Typography>
    </Box>
  )
}

export default FallbackCustomView
